/* 321 Cookie - designer analytics tracker
   Theme ASSET, loaded from the product Custom Liquid block with:
       <script src="{{ 'cookie-analytics.js' | asset_url }}" defer></script>
   It must come BEFORE cookie-designer.js in that block - deferred scripts
   execute in document order, so this guarantees window.CookieAnalytics exists
   before the designer runs.

   Lives in /assets for the same reason cookie-designer.js does: the Custom
   Liquid section is capped at 50,000 characters. Contains NO Liquid - keep it
   that way or it cannot live here.

   Exposes window.CookieAnalytics and nothing else. Every call is wrapped so a
   tracking failure can never break the designer.
*/
(function () {
  "use strict";

  var ENDPOINT = "https://stamp-ai-backend.vercel.app/api/analytics_event";
  var SID_KEY  = "cookieSessionId";
  var ATT_KEY  = "cookieAttemptCount";

  /* Our own tries (Mike, family, Claude testing) are marked so the admin
     dashboards can leave them out. Visit any page once with ?cd_internal=1 on
     each phone or browser to mark it; ?cd_internal=0 undoes it. The home
     network is recognised by the admin console on its own. */
  var INT_KEY  = "cd_internal";
  var internal = false;
  try {
    if (/[?&]cd_internal=1\b/.test(location.search)) localStorage.setItem(INT_KEY, "1");
    if (/[?&]cd_internal=0\b/.test(location.search)) localStorage.removeItem(INT_KEY);
    internal = localStorage.getItem(INT_KEY) === "1";
  } catch (e) {}

  function uid() {
    try {
      if (window.crypto && crypto.randomUUID) return "s_" + crypto.randomUUID();
    } catch (e) {}
    return "s_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  }

  /* sessionStorage, not memory: survives a reload inside the same tab, so a
     customer who refreshes and keeps trying stays ONE session. That reload is
     itself a signal worth catching. */
  var sid, isNew = false, reloaded = false;
  try {
    sid = sessionStorage.getItem(SID_KEY);
    if (!sid) { sid = uid(); sessionStorage.setItem(SID_KEY, sid); isNew = true; }
    else { reloaded = true; }
  } catch (e) { sid = uid(); isNew = true; }

  function attempts() {
    try { return parseInt(sessionStorage.getItem(ATT_KEY) || "0", 10) || 0; }
    catch (e) { return 0; }
  }
  function bumpAttempt() {
    var n = attempts() + 1;
    try { sessionStorage.setItem(ATT_KEY, String(n)); } catch (e) {}
    return n;
  }

  function send(event, designId, meta) {
    try {
      if (internal) {
        var m = { internal: 1 };
        if (meta) for (var k in meta) if (Object.prototype.hasOwnProperty.call(meta, k)) m[k] = meta[k];
        meta = m;
      }
      var body = JSON.stringify({
        event: event,
        session_id: sid,
        design_id: designId || null,
        meta: meta || null
      });
      /* sendBeacon survives page unload; fetch is the fallback. Both are
         fire-and-forget -- we never await, never read the response. */
      if (navigator.sendBeacon) {
        navigator.sendBeacon(ENDPOINT, new Blob([body], { type: "application/json" }));
      } else {
        fetch(ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: body,
          keepalive: true
        }).catch(function () {});
      }
    } catch (e) {}
  }

  var carted = false;

  window.CookieAnalytics = {
    sessionId: sid,
    internal: internal,

    /* Call right before firing a generate/upload request. Returns the attempt
       number, which should be passed to the backend as `attempt_number`. */
    startAttempt: function (info) {
      var n = bumpAttempt();
      send("generate_click", null, Object.assign({ attempt: n }, info || {}));
      return n;
    },

    attemptNumber: attempts,

    /* Tapping an older thumbnail is now the strongest mid-funnel intent
       signal available -- the baked cookie renders automatically, so there is
       no approve click. A reselect says every attempt since was worse. */
    reselected: function (designId) {
      send("design_reselect", designId, { attempt_now: attempts() });
    },
    styleSelected: function (style) { send("style_selected", null, { style: style }); },
    modeSelected: function (mode) { send("mode_selected", null, { mode: mode }); },

    /* Added 2026-08-25 with the designer popup. The designer is no longer inline
       on the product page, so "landed on the page" and "opened the designer" are
       now two different things -- and the gap between them is the first place a
       funnel can leak. designerAbandoned fires when the popup is closed with no
       design made at all, which is a different (and earlier) failure than
       abandon_hint below, where they generated something and never carted. */
    designerOpened: function (info) { send("designer_open", null, info || null); },
    designerAbandoned: function (info) { send("designer_abandon", null, info || null); },

    addedToCart: function (designId, style) {
      carted = true;
      send("add_to_cart", designId, { style: style, attempt: attempts() });
    },

    checkoutClicked: function () { send("checkout_click"); },

    /* Generic hook for one-off events (e.g. the biz_interstitial_* trio). The
       backend drops any name missing from ALLOWED_EVENTS in
       api/analytics_event.py, so add the name there too. */
    track: function (event, meta) { send(event, null, meta || null); },

    /* Hidden line-item properties. Merge into the /cart/add.js properties
       object so the order webhook can join the purchase back to the session. */
    cartProps: function (designId) {
      return {
        _session_id: sid,
        _attempt_number: String(attempts()),
        _design_id: designId || ""
      };
    }
  };

  if (isNew) {
    send("session_start", null, { referrer: document.referrer || null });
  } else if (reloaded) {
    send("page_reload", null, { attempts_so_far: attempts() });
  }

  /* Generated something, never carted -> the abandonment we care about. */
  window.addEventListener("pagehide", function () {
    try {
      if (!carted && attempts() > 0) {
        send("abandon_hint", null, { attempts: attempts() });
      }
    } catch (e) {}
  });
})();
